import { render } from "./OmnichannelOverviewDiagramaVenn.vue?vue&type=template&id=8bedf698&scoped=true"
import script from "./OmnichannelOverviewDiagramaVenn.vue?vue&type=script&lang=js"
export * from "./OmnichannelOverviewDiagramaVenn.vue?vue&type=script&lang=js"

import "./OmnichannelOverviewDiagramaVenn.vue?vue&type=style&index=0&id=8bedf698&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bedf698"]])

export default __exports__